import { months } from "../../../../../Utils/months";
import { calcularTotalesPorCategoria, calcularTotalesConSigno } from "./calculos";

export function calcularTodosLosTotales(data) {
    const ventasData = Array.isArray(data["VENTAS"]) ? data["VENTAS"] : [];
    const costoVentaData = Array.isArray(data["COSTO_VENTA"]) ? data["COSTO_VENTA"] : [];
    const gastosOperacionData = Array.isArray(data["GASTOS_OPERACION"]) ? data["GASTOS_OPERACION"] : [];
    const gastosFinancierosData = Array.isArray(data["GASTOS_FINANCIEROS"]) ? data["GASTOS_FINANCIEROS"] : [];
    const depreciacionesData = Array.isArray(data["DEPRECIACIONES"]) ? data["DEPRECIACIONES"] : [];
    const otrosIngresosGastosData = Array.isArray(data["OTROS_INGRESOS_GASTOS"]) ? data["OTROS_INGRESOS_GASTOS"] : [];
    const isrData = Array.isArray(data["ISR"]) ? data["ISR"] : [];
    const resultadoOperacionAgricolaData = Array.isArray(data["RESULTADO_OPERACION_AGRICOLA"]) ? data["RESULTADO_OPERACION_AGRICOLA"] : [];

    const ventasTotales = calcularTotalesPorCategoria(ventasData);
    const costoVentaTotales = calcularTotalesPorCategoria(costoVentaData);
    const gastosOperacionTotales = calcularTotalesPorCategoria(gastosOperacionData);
    const gastosFinancierosTotales = calcularTotalesPorCategoria(gastosFinancierosData);
    const depreciacionesTotales = calcularTotalesPorCategoria(depreciacionesData);
    const otrosIngresosGastosTotales = calcularTotalesConSigno(otrosIngresosGastosData, function(fila) {
        if (fila && fila.nombre && typeof fila.nombre === "string") {
            return fila.nombre.toLowerCase().indexOf("costo") !== -1 ? -1 : 1;
        }
        return 1;
    });
    const isrTotales = calcularTotalesPorCategoria(isrData);
    const resultadoOperacionAgricolaTotales = calcularTotalesPorCategoria(resultadoOperacionAgricolaData);

    const resultadoBrutoTotales = {};
    const resultadoOperacionTotales = {};
    const resultadoComercializacionTotales = {};
    const resultadoDespuesImpuestosTotales = {};
    const resultadoCombinadoTotales = {};

    months.forEach(function(month) {
        const key = month.toLowerCase();

        resultadoBrutoTotales[key] = {
            presupuestado: (ventasTotales[key] && ventasTotales[key].presupuestado || 0) - (costoVentaTotales[key] && costoVentaTotales[key].presupuestado || 0),
            ejecutado: (ventasTotales[key] && ventasTotales[key].ejecutado || 0) - (costoVentaTotales[key] && costoVentaTotales[key].ejecutado || 0),
            variacion: (ventasTotales[key] && ventasTotales[key].variacion || 0) - (costoVentaTotales[key] && costoVentaTotales[key].variacion || 0),
        };

        resultadoOperacionTotales[key] = {
            presupuestado: (resultadoBrutoTotales[key] && resultadoBrutoTotales[key].presupuestado || 0) - (gastosOperacionTotales[key] && gastosOperacionTotales[key].presupuestado || 0),
            ejecutado: (resultadoBrutoTotales[key] && resultadoBrutoTotales[key].ejecutado || 0) - (gastosOperacionTotales[key] && gastosOperacionTotales[key].ejecutado || 0),
            variacion: (resultadoBrutoTotales[key] && resultadoBrutoTotales[key].variacion || 0) - (gastosOperacionTotales[key] && gastosOperacionTotales[key].variacion || 0),
        };

        resultadoComercializacionTotales[key] = {
            presupuestado: (resultadoOperacionTotales[key] && resultadoOperacionTotales[key].presupuestado || 0) + (otrosIngresosGastosTotales[key] && otrosIngresosGastosTotales[key].presupuestado || 0) - (gastosFinancierosTotales[key] && gastosFinancierosTotales[key].presupuestado || 0) - (depreciacionesTotales[key] && depreciacionesTotales[key].presupuestado || 0),
            ejecutado: (resultadoOperacionTotales[key] && resultadoOperacionTotales[key].ejecutado || 0) + (otrosIngresosGastosTotales[key] && otrosIngresosGastosTotales[key].ejecutado || 0) - (gastosFinancierosTotales[key] && gastosFinancierosTotales[key].ejecutado || 0) - (depreciacionesTotales[key] && depreciacionesTotales[key].ejecutado || 0),
            variacion: (resultadoOperacionTotales[key] && resultadoOperacionTotales[key].variacion || 0) + (otrosIngresosGastosTotales[key] && otrosIngresosGastosTotales[key].variacion || 0) - (gastosFinancierosTotales[key] && gastosFinancierosTotales[key].variacion || 0) - (depreciacionesTotales[key] && depreciacionesTotales[key].variacion || 0),
        };

        resultadoDespuesImpuestosTotales[key] = {
            presupuestado: (resultadoComercializacionTotales[key] && resultadoComercializacionTotales[key].presupuestado || 0) - (isrTotales[key] && isrTotales[key].presupuestado || 0),
            ejecutado: (resultadoComercializacionTotales[key] && resultadoComercializacionTotales[key].ejecutado || 0) - (isrTotales[key] && isrTotales[key].ejecutado || 0),
            variacion: (resultadoComercializacionTotales[key] && resultadoComercializacionTotales[key].variacion || 0) - (isrTotales[key] && isrTotales[key].variacion || 0),
        };

        resultadoCombinadoTotales[key] = {
            presupuestado: (resultadoDespuesImpuestosTotales[key] && resultadoDespuesImpuestosTotales[key].presupuestado || 0) + (resultadoOperacionAgricolaTotales[key] && resultadoOperacionAgricolaTotales[key].presupuestado || 0),
            ejecutado: (resultadoDespuesImpuestosTotales[key] && resultadoDespuesImpuestosTotales[key].ejecutado || 0) + (resultadoOperacionAgricolaTotales[key] && resultadoOperacionAgricolaTotales[key].ejecutado || 0),
            variacion: (resultadoDespuesImpuestosTotales[key] && resultadoDespuesImpuestosTotales[key].variacion || 0) + (resultadoOperacionAgricolaTotales[key] && resultadoOperacionAgricolaTotales[key].variacion || 0),
        };
    });

    const totalesMap = {
        VENTAS: ventasTotales,
        COSTO_VENTA: costoVentaTotales,
        GASTOS_OPERACION: gastosOperacionTotales,
        GASTOS_FINANCIEROS: gastosFinancierosTotales,
        DEPRECIACIONES: depreciacionesTotales,
        OTROS_INGRESOS_GASTOS: otrosIngresosGastosTotales,
        ISR: isrTotales,
        RESULTADO_BRUTO: resultadoBrutoTotales,
        RESULTADO_OPERACION: resultadoOperacionTotales,
        RESULTADO_COMERCIALIZACION: resultadoComercializacionTotales,
        RESULTADO_DESPUES_IMPUESTOS: resultadoDespuesImpuestosTotales,
        RESULTADO_OPERACION_AGRICOLA: resultadoOperacionAgricolaTotales,
        RESULTADO_COMBINADO: resultadoCombinadoTotales,
    };

    return {
        totalesMap,
    };
}
